import _ from 'lodash'
import codes from '@/f1/codes'
import { VclFacebook } from 'vue-content-loading';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components : { VclFacebook },
  name: 'RuleSelector',
  props: ['rule_selected', 'rule_data', 'version', 'mode', 'level', 'rule_block', "rule_detect", 'opened'],
  computed: {
  },
  watch: {
    rule_selected() {
      this.rule_sel = this.rule_selected;
      // if(this.mode == 'On') { this.detect = this.firewall_mode }
      // if(this.mode == 'DetectionOnly') { this.block = this.firewall_mode }
      this.parser_setting()
      console.info("watch updated props data rule")
    },
    mode(){
      // 모드 변경에 따른 리로드 필요
      // 차단 되었던 부분 초기화
      if(this.mode == codes.WAF_MODE_DETECTIONONLY.VALUE) {
        this.$parent.$emit('block_policy', [])
        this.$parent.$emit('detect_policy', [])
        // 룰 전체 탐지모드로 변경
      }
      // 탐지만 되었던 부분 초기화
      // if(this.mode == codes.WAF_MODE_ON.VALUE) { this.$parent.$emit('detect_policy', []) }

      if(this.mode > codes.WAF_MODE_OFF.VALUE) {
        _.forEach(this.rule_data, r => {
          r.rules.forEach(s => {
            // console.info("toggle mode 1", s.mode, this.mode)
            s.mode  = this.mode < 2 ? false : _.indexOf(this.detect, s.key) > -1 ? false : true
            // console.info("toggle mode 2", s.mode, this.mode)
          })
        })
      }
      console.info("watch updated props data mode", this.mode)
      this.parser_setting()
    },
    level(){
      // 레벨 변경에 따른 리로드 필요
      console.info("watch updated props data level")
      // this.parser_setting(true)
    },
  },
  data: () => {
    return {
      loading : true,
      all_open_status : false,
      is_changed : false,
      detect : [],
      block : [],
      all_usage_status : false,
      sub_status : false,
      rule_sel : [],
    }
  },
  methods: {
    toss_change_list() {
      let changed = _.compact(_.map(this.rule_data, r => {
        let s = _.filter(r.rules, s => s.origin_use != s.use || s.origin_mode != s.mode)
        return s.length > 0 ? s : null
      }))
      this.$parent.$emit('is_changed', changed)
    },
    is_changed_rule(rindex) {
      return this.rule_data && _.filter(this.rule_data[rindex].rules, x => x.origin_use != x.use || x.origin_mode != x.mode).length > 0
    },
    status_count : function(key, is_use=true) { return _.filter(_.filter(this.rule_data, x => x.key == key)[0].rules, r => r.use == is_use).length },
    rule_mode_toggle(rindex, sindex) {
      this.is_changed = true;
      try {
        // console.log("rindex, sindex", rindex, sindex, this.rule_data[rindex].rules[sindex].mode)
        if(this.mode < codes.WAF_MODE_ON.VALUE) { return this.$toastr.w(`${i18n_toastr._i18n_warning.rule_mode_check[this.i18n]}`) }
        this.rule_data[rindex].rules[sindex].mode = !this.rule_data[rindex].rules[sindex].mode
        if(this.rule_data[rindex].rules[sindex].mode) {
          this.detect = _.filter(this.block, b => b != this.rule_data[rindex].rules[sindex].key)
          this.block.push(this.rule_data[rindex].rules[sindex].key)
        } else {
          this.block = _.filter(this.block, b => b != this.rule_data[rindex].rules[sindex].key)
          this.detect.push(this.rule_data[rindex].rules[sindex].key)
        }

        // counting and apply
        this.rule_data[rindex].detect = this.rule_data[rindex].block = 0
        this.rule_data[rindex].block = _.filter(this.rule_data[rindex].rules, { mode : true }).length
        this.rule_data[rindex].detect = this.rule_data[rindex].rules.length - this.rule_data[rindex].block
        this.block = _.uniq(this.block)
        this.$parent.$emit('block_policy', this.block)
        this.$parent.$emit('detect_policy', this.detect)
        this.$forceUpdate()

        this.emit_changed()
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_1[this.i18n]}`) }
    },
    rule_mode_toggle_all(rindex) {
      try {
        if(this.mode < codes.WAF_MODE_ON.VALUE) { return this.$toastr.w(`${i18n_toastr._i18n_warning.rule_mode_check[this.i18n]}`) }
        _.forEach(this.rule_data[rindex].rules, (s, sindex) =>  this.rule_mode_toggle(rindex, sindex) )
      } catch (e) { console.log(e); this.$toastr.e("load error #2") }
    },
    getLevel(s) { return s && s.length == 3 ? Number(s.substring(2, 3)) : '-' },
    ruleOpenOrCloseAll() {
      try {
        this.loading = true
        const reload = () => {
          this.all_open_status = !this.all_open_status
          // this.$toastr.i("loading " + (this.all_open_status ? 'Open' : 'Close'))
          _.forEach(this.rule_data, (r, rindex) => this.open_toggle(rindex, this.all_open_status))
          // this.$toastr.s("Refreshed")
          this.loading = false
        }
        setTimeout(reload, 300)
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_3[this.i18n]}`) }
    },
    all_toggle(value) {
      try {
        for (let rindex = 0; rindex < this.rule_data.length; rindex++) { this.policy_toggle(rindex, -1, value) }
        this.check_all_toggle()
        if(value == false) { this.sub_status = value }
        if(this.all_usage_status == true) {
          console.log('all usage => remove selected rule', this.rule_sel.length)
          // this.$parent.$emit('rule_sel', [])
          this.is_changed = true;
        }

        this.refresh()
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_4[this.i18n]}`) }
    },
    toss_rule() {
      try {
        let rules = _.filter(this.rule_sel, x => {
          return true &&
            Number(x) >= 4200000 &&
            !(Number(x) >= 4200011 && Number(x) <= 4200026)  &&
            !(Number(x) >= 9001000 && Number(x) <= 9001216) &&
            !(Number(x) >= 9002000 && Number(x) <= 9002900)
        })


        if(!this.is_changed) { rules =  _.concat(rules, this.rule_sel && this.rule_sel.length > 0 ? this.rule_sel : []) }

        // 미사용 정책
        _.forEach(this.rule_data, r => _.forEach(r.rules, s => {
          // console.log(!s.use, s.level <= this.level, s.key)
          !s.use && s.level <= this.level ? rules.push(s.key) : ''
        }))

        // console.debug("is change?", this.is_changed, 'rules', rules)
        _.pull(rules, "900", "901", "903.9001", "903.9002", "905", "910", "911", "912", "913", "920", "921", "930", "931", "932", "933", "941", "942", "943", "949", "420", "950", "951", "952", "953", "954", "959", "980")

        // return
        // 부모 뷰에서 mode_change 운영 모드 업데이트
        // this.$parent.$emit("mode_change", this.mode == "On" ?  this.detect : this.block)
        // 부모 뷰에서 policy_rule 정책 업데이트
        console.log("toss_rule", rules)
        // return
        this.$parent.$emit("policy_rule", rules)
        this.is_changed = false;
        this.refresh()

        console.log("save ended", rules.length)
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_5[this.i18n]}`) }
    },
    policy_toggle(rindex, sindex=-1, val=undefined) {
      try {
        // console.log(rindex, sindex, val)
        this.is_changed = true;
        if(sindex != -1) {
          // sub rule
          this.rule_data[rindex].rules[sindex].use = val != undefined ? val : !this.rule_data[rindex].rules[sindex].use
          // 사용하는게 하나라도 있으면 상위 사용 처리
          let counting = _.filter(this.rule_data[rindex].rules, s => s.use == true).length
          this.rule_data[rindex].use = counting > 0 ? true : false
          this.rule_data[rindex].indeterminate = counting == 0 || counting == this.rule_data[rindex].rules.length ? false : true;
        } else {
          // main rule
          let counting = 0
          this.rule_data[rindex].use = val != undefined ? val : !this.rule_data[rindex].use;
          this.rule_data[rindex].rules = _.map(this.rule_data[rindex].rules, s => {
            console.debug("the rule more high level then setting", s.level, this.level)
            if(s.level > this.level) {
              return s
            }
            s.use = this.rule_data[rindex].use
            counting = s.use ? counting+1 : counting
            return s
          })

          this.rule_data[rindex].indeterminate = this.rule_data[rindex].use

          if(this.rule_data[rindex].rules.length == counting || counting == 0) {
            this.rule_data[rindex].indeterminate = false
            if(counting == 0) {
              this.rule_data[rindex].use = false
            }
          }
          if(this.rule_data[rindex].indeterminate) { this.sub_status = true }
          // if(val != undefined && this.rule_data[rindex].use == false) { this.rule_data[rindex].indeterminate = false }
        }
        this.check_all_toggle()

        // 부모 뷰에 전파, 그래서 룰서비스 컴포넌트에서 가능
        this.update_quick_setting(this.rule_data[rindex])


        this.emit_changed()
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_5[this.i18n]}`) }
    },
    emit_changed() {
      let changed = []
      _.forEach(this.rule_data, r => _.filter(r.rules, s => s.origin_use != s.use || s.origin_mode != s.mode).forEach(c => changed.push(c)))

      this.$parent.$emit('is_changed', changed)
      console.log('changed', changed.length)
    },
    check_all_toggle(){
      try {
        // check indeterminate
        let counting_indeterminate = _.filter(this.rule_data, { indeterminate : true }).length
        // -1 은 900 rule
        let counting_use = _.filter(this.rule_data, { use : true }).length - 1

        // console.log('counting_use', counting_use, "counting_indeterminate", counting_indeterminate)
        if(counting_use <= 0) {
          this.all_usage_status = false
          this.sub_status = this.all_usage_status
          if(counting_indeterminate  == 0) {
            // this.sub_status = true
            return
          } else if(counting_indeterminate > 0) {
            // 같은 루틴 A
            this.sub_status = !(counting_indeterminate == this.rule_data.length)
            this.all_usage_status = (counting_indeterminate == this.rule_data.length)
          }
        } else if(counting_use > 0) {
          // 같은 루틴 A
          // console.log('test', counting_use, this.rule_data.length, counting_indeterminate)
          if(counting_indeterminate > 0) {
            this.sub_status = true
          } else {
            this.sub_status = !(counting_use == this.rule_data.length - 1)
          }

          this.all_usage_status = (counting_use == this.rule_data.length -1)
        }

      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_5[this.i18n]}`) }
    },
    open_toggle(rindex, value = undefined) {
      this.rule_data[rindex].open = value != undefined ? value : !this.rule_data[rindex].open
      this.$parent.$emit('rule_open', { key : this.rule_data[rindex].key, value : this.rule_data[rindex].open })
    },
    refresh() {
      // this.$parent.reload();
      this.$parent.$emit("refresh")
    },
    // r => main rule
    update_quick_setting(r)
    {
      try {
        let data = {}
        switch (r.key) {
          case '903.9001': data = { DRUPAL : { use : r.use, key : this.parser_rule('DRUPAL'), indeterminate : r.indeterminate } }; break;
          case '903.9002': data = { WORDPRESS : { use : r.use, key : this.parser_rule('WORDPRESS'), indeterminate : r.indeterminate } }; break;
          case '952': data = { JAVA : { use : r.use, key : this.parser_rule('JAVA'), indeterminate : r.indeterminate } }; break;
          case '953': data = { PHP : { use : r.use, key : this.parser_rule('PHP'), indeterminate : r.indeterminate } }; break;
          case '954': data = { IIS : { use : r.use, key : this.parser_rule('IIS'), indeterminate : r.indeterminate } }; break;
          default: break;
        }
        if(data != {}) { this.$parent.$emit('quick_policy_one', data) }
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_6[this.i18n]}`) }
    },
    parser_rule(keyword) {
      return _.map(_.filter(this.rule_data, r => r.desc.indexOf(keyword) > -1), i => i.key)
    },
    async parser_setting(priority_level = false) {
      try {
        this.sub_status = this.all_usage_status = false
        this.rule_sel = this.rule_selected;
        // console.log('info', this.rule_block, this.rule_detect)
        console.log('load block', this.rule_bloc ? this.rule_block.length : 0)
        console.log('load detect', this.rule_detect ? this.rule_detect.length : 0)

        _.forEach(this.rule_data, r => {

          let key = r.key.indexOf('.') > -1 ? r.key.split('.')[1] : r.key

          // 컴포넌트 재생성으로 인한 이전 오픈 여부 기록에 의해 화면 다시 표시
          r.open = this.opened[key]

          // 블럭인지 탐지인지 구분
          let block_count = 0
          // 룰별 운영 모드 분리 해야 함
          r.rules.forEach(s => {
            // s.open = this.all_open_status
            let block_index = _.indexOf(this.rule_block, s.key)
            let detect_index = _.indexOf(this.rule_detect, s.key)

            // s.key.startsWith('901') ? console.log("test", detect_index, this.detect) : ''
            if(block_index > -1) {
              s.mode = true
              this.block.push(s.key)
            }
            else if(detect_index > -1) {
              s.mode = false
              this.detect.push(s.key)
            }
            else  {
              // s.key.startsWith('901') ? console.log("follow system config", s.mode, !(this.mode < 2), '!(this.mode < 2)') : ''
              s.mode = !(this.mode < 2)
              // 시스템 설정 따라 감

            }
            // s.mode  = this.mode < 2 ? false : block_index < 0 && detect_index < 0 ? true : false
            if(s.mode) { block_count += 1 }
          })

          // 룰별 운영 모드 카운팅
          r.block = block_count
          r.detect = r.rules.length - r.block

          // 아래부터 리턴 가능

          // +3 꼭 필요함
          // startsWith 으로만은 필터링이 힘듦
          let rs = _.uniq(_.filter(this.rule_sel, del => _.startsWith(del, key) && (key.length == 3 || (key.length == 4 && (key.length + 3) == del.length)))).length
          if(r.rules.length == rs) {
            // console.log(r.key, 'all usable')
              // 전체 미사용할 경우
              r.indeterminate = r.use = false
              _.forEach(r.rules, sub => sub.use = r.use)
            // return
          } else {
            if(rs == 0) {
              // 전체 사용할 경우
              // console.log(r.key, 'all usable')
              r.indeterminate = false
              r.use = true
              _.forEach(r.rules, sub => sub.use = r.use)
              // return
            }
          }
          r.origin_use = r.use
          r.origin_mode = r.mode
          // console.log(r.key, r.rules.length, rs)
          r.indeterminate = rs > 0 ? true : false
          let counting = 0
          // total += rs

          // 선택한 룰일 경우 false(미사용 처리된) 리턴
          // 룰 메인키가 사용으로 되어 있을 경우
          _.forEach(r.rules, s => {

            // for (let i = 0; i < r.rules.length; i++) {
              // let s = r.rules[i];
              // 1. 하위 룰에서 미사용 처리된 룰 확인, 미사용이면 돈 터치
              let is_disabled = _.includes(this.rule_sel, s.key)
              s.level = this.getLevel(s.paranoia_level)
              // s.use = s.level > this.level ? false : true

              if(priority_level == true) {
                // console.log(s.key, 'is_disabled', is_disabled, 's.use', s.use, 's.level', s.level, 'this.level', this.level)
                if(is_disabled) {
                  s.use = false
                } else{
                  s.use = s.level > this.level ? false : true
                }

              } else {
                // console.log('WTF', s.key, 'is_disabled', is_disabled, 's.use', s.use, 's.level', s.level, 'this.level', this.level)
                s.use = s.level > this.level ? false : true
                if(is_disabled) {
                  s.use = !is_disabled
                }
              }

              // if(priority_level == false || is_disabled == true) {
              //   if(priority_level == true) {

              //   }

              //   // if(!priority_level) { return }

              // } else {
              //   // 사용중일경우
              //   s.use = s.level > this.level ? false : true
              // }




              // if(s.use == true) {
              //   s.use = s.level > this.level ? false : true
              // }



              // this.origin[rindex].rules[sindex].use = s.use
              if(s.use) { counting += 1 }
              s.origin_use = s.use
              s.origin_mode = s.mode
              // }
          })
          this.is_changed = true

          // 전체 사용이 아닐 경우 설정
          counting = _.filter(r.rules, { use : true }).length
          r.indeterminate = counting == 0 || r.rules.length == counting ? false : true
          if(counting == 0) {
            r.use = false
          }
          // quick setting toss : 부모 뷰에 전파, 그래서 룰서비스 컴포넌트에서 가능
          this.update_quick_setting(r)
        }

      );
      this.check_all_toggle()

      this.$forceUpdate()

      console.log("refreshed setting", priority_level)
      this.loading = false
      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_7[this.i18n]}`) }
    },
  },
  created: function() {   console.log('RuleSelector.vue', 'created'); },
  destroyed: function() { console.log('RuleSelector.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleSelector.vue', 'mounted');
    this.parser_setting()
  }
}
